import { useTranslation } from "react-i18next";
import { PlatformMenu } from "@/partner/features/platformMenu";
import { Meta } from "@/shared/components";

export const PlatformMenuPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("platformMenu.pageTitle")} pageType="Partner" />
      <PlatformMenu />
    </>
  );
};
